var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(-755 -2627)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(755 2627)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_living_room",
    d: "M10.091,4A5.4,5.4,0,0,0,4.636,9.294v3.86A5.323,5.323,0,0,0,1,18.118v7.059a5.4,5.4,0,0,0,5.455,5.294H8.273V34h3.636V30.471H30.091V34h3.636V30.471h1.818A5.4,5.4,0,0,0,41,25.176V18.118a5.323,5.323,0,0,0-3.636-4.963V9.294A5.4,5.4,0,0,0,31.909,4Zm0,3.529H31.909a1.764,1.764,0,0,1,1.818,1.765v3.86a5.323,5.323,0,0,0-3.636,4.963v1.765H11.909V18.118a5.323,5.323,0,0,0-3.636-4.963V9.294A1.764,1.764,0,0,1,10.091,7.529ZM6.455,16.353a1.764,1.764,0,0,1,1.818,1.765v5.294H33.727V18.118a1.819,1.819,0,0,1,3.636,0v7.059a1.764,1.764,0,0,1-1.818,1.765H6.455a1.764,1.764,0,0,1-1.818-1.765V18.118A1.764,1.764,0,0,1,6.455,16.353Z",
    transform: "translate(774 2648)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon11);
export default __webpack_public_path__ + "static/media/facilityIcon11.75bdbd285ca77b52ea1b10844ce23f2a.svg";
export { ForwardRef as ReactComponent };